import moment from 'moment'
export function sexy(value) {
  if (!value) return ''
  return value == 1 ? '男' : value == 2 ? '女' : '不详'
}

export function formatText(value) {
  return value ? value : '-'
}

export function format(value, type) {
  if (value) {
    type = type || 'YYYY-MM-DD HH:mm:ss';
    return moment(value).format(type)
  } else {
    return '-'
  }
}

export function formatCity(value) {
  if(!value) return '';
  let str = '';
  value.forEach( x => {
    str += x.city_name + ' ';
  });
  return str || '不限'
}

export function basicSalaryPeriod(val) {
  let arr = ['', '小时', '天', '周', '月', '次', '其他']
  return arr[val]
}